import { Head, Link, usePage } from '@inertiajs/react'
import Device from './device'
import { DeviceType } from './types'

interface ShowProps {
  device: DeviceType
}

export default function Show({ device }: ShowProps) {
  const { flash } = usePage()

  return (
    <>
      <Head title={`Device #${device.id}`} />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <div className="mx-auto">
          {flash.notice && (
            <p className="py-2 px-3 bg-green-50 mb-5 text-green-500 font-medium rounded-lg inline-block">
              {flash.notice}
            </p>
          )}

          <h1 className="font-bold text-4xl">Device #{device.id}</h1>

          <Device device={device} />

          <Link
            href={`/devices/${device.id}/edit`}
            className="mt-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
          >
            Edit this device
          </Link>
          <Link
            href="/devices"
            className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
          >
            Back to devices
          </Link>
          <div className="inline-block ml-2">
            <Link
              href={`/devices/${device.id}`}
              as="button"
              method="delete"
              className="mt-2 rounded-lg py-3 px-5 bg-gray-100 font-medium"
            >
              Destroy this device
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
